export const data = {
	data() {
		return {
			headerList: [
				{
					prop: 'product_title',
					label: '课程标题',
					width: 120
				},
				{
					prop: 'pay_amount',
					label: '支付金额',
					align: 'center',
					width: 120
				},
				{
					prop: 'status',
					label: '订单状态',
					width: 100
				},
				{
					prop: 'commission_nickname',
					label: '推广人视频号',
					width: 150
				},
				{
					prop: 'nick_nake',
					label: '购买人',
					width: 130
				},
				{
					prop: 'author_income',
					label: '实际收益',
					width: 100
				},
				{
					prop: 'income_status_desc',
					label: '收益状态',
					width: 90
				},
				{
					prop: 'commission_amount',
					label: '达人佣金',
					width: 90
				},
				{
					prop: 'customer_notes',
					label: '订单备注',
					width: 120
				}
			]
		}
	}
}